import { CircleMultipleIcon } from './CircleMultipleIcon';

/**
 * author: Michael Richins
 * id C05A4C2F-8128-474F-B204-D782A332CB73
 * name circle-multiple
 * version: 2.8.94
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/circle-multiple.svg
 * tags
 * - Currency 
 * - Banking 
 */
export const CoinsIcon = CircleMultipleIcon;
export default CoinsIcon